{
  "name": "smartclock-backoffice",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "dev": "ng serve --configuration=development",
    "sta": "ng serve --configuration=staging",
    "prod": "ng serve --configuration=production",
    "build": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build",
    "build:dev": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration=development",
    "build:sta": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration=staging",
    "build:prod": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "format": "prettier --write \"src/**/*.{ts,html,css,scss,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,css,scss,json}\"",
    "e2e": "playwright test -c e2e --project=setup --project=smoke --project=visual",
    "e2e:update-snapshots": "playwright test -c e2e --project=setup --project=visual --update-snapshots",
    "e2e:parity": "playwright test -c e2e --project=parity",
    "test": "node --test scripts/check-ui-isolation.test.mjs && node scripts/check-ui-isolation.mjs && node scripts/check-grid-contract.mjs && ng test --watch=false"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "engines": {
    "node": "^24.22.1 || ^26.12.1"
  },
  "dependencies": {
    "@angular/cdk": "^22.2.5",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "opus-recorder": "^8.0.5",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.5",
    "@angular/cli": "^22.2.5",
    "@angular/compiler-cli": "^22.2.3",
    "@playwright/test": "1.64.1",
    "@types/qrcode": "^1.5.6",
    "@vitest/browser-playwright": "5.0.5",
    "autoprefixer": "^10.4.22",
    "baseline-browser-mapping": "^2.10.11",
    "postcss": "^8.5.6",
    "prettier": "^3.7.4",
    "tailwindcss": "^3.4.18",
    "typescript": "~6.0.3",
    "vitest": "5.0.5"
  }
}
